import React from 'react';

const Git = () => {
  return (
    <div className="content-page">
      <h1>Git Tutorial</h1>
      
      <div className="tutorial-section">
        <h2>What is Git?</h2>
        <p>Git is a distributed version control system that helps track changes in source code during software development. It is designed for coordinating work among programmers, but it can be used to track changes in any set of files.</p>
      </div>

      <div className="example">
        <h3>Basic Git Commands</h3>
        <div className="code-container">
          <pre>{`# Initialize a new Git repository
git init

# Clone an existing repository
git clone https://github.com/username/repository.git

# Check the status of your working directory
git status

# Stage changes for commit
git add filename.txt
git add .  # Stage all changes

# Commit changes with a message
git commit -m "Initial commit"

# Connect to a remote repository
git remote add origin https://github.com/username/repository.git

# Push changes to the remote repository
git push -u origin main

# Pull the latest changes from the remote repository
git pull origin main

# Create a new branch
git branch new-feature

# Switch to a branch
git checkout branch-name

# Merge changes from another branch
git merge branch-name`}</pre>
          <button className="try-it-btn">Try it in Terminal »</button>
        </div>
      </div>

      <div className="tutorial-section">
        <h2>Git Workflow</h2>
        <p>A typical Git workflow involves the following steps:</p>
        <ol>
          <li>Create a new branch for your feature or bugfix</li>
          <li>Make changes to the code</li>
          <li>Stage your changes with `git add`</li>
          <li>Commit your changes with a descriptive message</li>
          <li>Push your changes to the remote repository</li>
          <li>Create a pull request to merge your changes into the main branch</li>
        </ol>
      </div>

      <div className="tutorial-navigation">
        <button className="btn-prev">❮ Previous</button>
        <button className="btn-next">Next ❯</button>
      </div>
    </div>
  );
};

export default Git;
